import { FunctionalComponent, h } from '@stencil/core';
import { AppCard } from './';

interface SectionCards {
    __component?: string;
    data?: any;
}


export const SectionCards: FunctionalComponent<SectionCards> = ({data}) => {

    const { Title, Description, Cards, RemoveTopMargin } = data

    return (
        <section class={`uk-section ${RemoveTopMargin ? 'uk-padding-remove-top' : ''}`}>
            <div class="uk-container">
                <div hidden={!Title && !Description} class="uk-text-center@s uk-padding@s uk-padding-remove-top uk-padding-remove-horizontal">
                    <h2 hidden={!Title} class="uk-heading-xlarge wsio-darker-green">
                        {Title}
                    </h2>
                    <p hidden={!Description} class=" uk-container uk-container-xsmall wsio-dark-grey">
                        {Description}
                    </p>
                </div>
                <div class={`${!Title && !Description ? 'uk-padding-remove-top' : ''}`}>
                    <div class="uk-flex-center uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m uk-grid-small" uk-grid>
                        {Cards.map(({ Title, Media, page }) => <AppCard Title={Title} Media={Media} Page={page} />)}
                    </div>
                </div>
            </div>
        </section>
    )
};